/* Bali search panel (duplicate theme). Replaces the stock predictive dropdown of the header search.
   Data: Shopify predictive search rendered by sections/bali-predictive-search.liquid, and the real total from
   sections/bali-search-count.liquid. The stock SearchBar keeps handling focus, mobile full-screen and submit. */
(function () {
  'use strict';

  var wrapper = document.querySelector('.header__search-bar-wrapper');
  if (!wrapper) return;
  var form = wrapper.querySelector('form.search-bar');
  var input = form && form.querySelector('input[name="q"]');
  if (!form || !input) return;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var searchUrl = (window.routes && window.routes.searchUrl) || root + 'search';
  var money = function (cents) { return '$' + Math.round(cents / 100).toLocaleString('es-CO'); };
  var esc = function (s) { return String(s).replace(/[&<>"']/g, function (c) { return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]; }); };

  form.classList.add('bali-sx-form');
  var panel = document.createElement('div');
  panel.className = 'bali-sx';
  panel.setAttribute('aria-hidden', 'true');
  panel.setAttribute('role', 'dialog');
  panel.setAttribute('aria-label', 'Resultados de búsqueda');
  form.appendChild(panel);

  var inputWrapper = form.querySelector('.search-bar__input-wrapper');
  var ghost = document.createElement('span');
  ghost.className = 'bali-sx-ghost';
  ghost.setAttribute('aria-hidden', 'true');
  if (inputWrapper) inputWrapper.appendChild(ghost);

  var timer = null;
  var lastToken = 0;
  var state = { typed: '', effective: '', completion: '', total: null, activeChip: 'all', activeIndex: -1 };

  function isOpen() { return panel.getAttribute('aria-hidden') === 'false'; }
  function open() {
    panel.setAttribute('aria-hidden', 'false');
    form.classList.add('bali-sx-open');
    document.documentElement.classList.add('bali-sx-active');
    place();
  }
  function close() {
    panel.setAttribute('aria-hidden', 'true');
    form.classList.remove('bali-sx-open');
    document.documentElement.classList.remove('bali-sx-active');
    state.activeIndex = -1;
  }

  // Desktop: a wide panel centered in the viewport, below the search bar. Phone: full width under the input.
  function place() {
    var formRect = form.getBoundingClientRect();
    if (window.matchMedia('(max-width: 640px)').matches) {
      var top = (form.querySelector('.search-bar__top-wrapper') || form).getBoundingClientRect().bottom;
      panel.style.left = '';
      panel.style.width = '';
      panel.style.maxHeight = (window.innerHeight - top - 8) + 'px';
      return;
    }
    var width = Math.min(1180, window.innerWidth - 48);
    panel.style.width = width + 'px';
    panel.style.left = Math.round((window.innerWidth - width) / 2 - formRect.left) + 'px';
    panel.style.maxHeight = (window.innerHeight - formRect.bottom - 24) + 'px';
  }

  function setGhost() {
    var typed = input.value;
    var c = state.completion;
    if (!typed || !c || c.toLowerCase() === typed.toLowerCase()) { ghost.innerHTML = ''; return; }
    if (c.toLowerCase().indexOf(typed.toLowerCase()) === 0) {
      ghost.innerHTML = '<span class="bali-sx-ghost__typed">' + esc(typed) + '</span>' + esc(c.slice(typed.length));
    } else {
      ghost.innerHTML = '<span class="bali-sx-ghost__typed">' + esc(typed) + '</span> → ' + esc(c);
    }
  }

  function fetchPanel(term) {
    var url = root + 'search/suggest?section_id=bali-predictive-search&q=' + encodeURIComponent(term) +
      '&resources[type]=product,collection,query&resources[limit]=10&resources[limit_scope]=each';
    return fetch(url, { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (html) {
      var tmp = document.createElement('div');
      tmp.innerHTML = html;
      return tmp.querySelector('.bali-sx__data');
    });
  }
  function fetchCount(term) {
    var url = searchUrl + '?section_id=bali-search-count&type=product&options[prefix]=last&q=' + encodeURIComponent(term);
    return fetch(url, { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (html) {
      var m = html.match(/data-count="(\d+)"/);
      return m ? parseInt(m[1], 10) : null;
    }).catch(function () { return null; });
  }

  function run() {
    var typed = input.value.trim();
    var token = ++lastToken;
    state.typed = typed;
    if (!typed) { state.completion = ''; setGhost(); close(); return; }
    form.classList.add('bali-sx-loading');
    fetchPanel(typed).then(function (data) {
      if (token !== lastToken || !data) return null;
      var firstQuery = data.getAttribute('data-first-query') || '';
      state.completion = firstQuery;
      setGhost();
      // No products for what was typed, but Shopify suggests a query: show that query instead (real data only).
      if (data.getAttribute('data-products') === '0' && firstQuery && firstQuery.toLowerCase() !== typed.toLowerCase()) {
        return fetchPanel(firstQuery).then(function (alt) {
          return alt && alt.getAttribute('data-products') !== '0' ? { data: alt, effective: firstQuery } : { data: data, effective: typed };
        });
      }
      return { data: data, effective: typed };
    }).then(function (res) {
      if (!res || token !== lastToken) return;
      state.effective = res.effective;
      state.activeChip = 'all';
      state.activeIndex = -1;
      panel.innerHTML = res.data.innerHTML;
      renderShowing();
      state.total = null;
      return refineResults(token).then(function () {
        if (token !== lastToken) return;
        renderChips();
        applyFilter();
        form.classList.remove('bali-sx-loading');
        open();
        if (state.relatedMode) return;
        fetchCount(res.effective).then(function (total) {
          if (token !== lastToken || total === null) return;
          state.total = total;
          renderTotals();
        });
      });
    }).catch(function () { form.classList.remove('bali-sx-loading'); });
  }

  // Shopify's typo tolerance brings products that only "look like" the word (azafata -> Azrael, Zafari).
  // Keep the products whose title really contains the words; fill the rest with products related to the first
  // real match (Shopify product recommendations), and always list sold-out products last.
  function norm(s) { return String(s || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase(); }
  function refineResults(token) {
    state.relatedMode = false;
    state.exact = 0;
    var list = cards();
    var words = norm(state.effective).split(/[^a-z0-9ñ]+/).filter(function (w) { return w.length >= 3; });
    if (!list.length || !words.length) { orderCards(list, []); return Promise.resolve(); }
    var isMatch = function (c) {
      var title = norm(c.getAttribute('data-title'));
      return words.every(function (w) { return new RegExp('(^|[^a-z0-9])' + w.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')).test(title); });
    };
    var matches = list.filter(isMatch);
    var others = list.filter(function (c) { return !isMatch(c); });
    state.exact = matches.length;
    if (!matches.length || !others.length) { orderCards(list, []); return Promise.resolve(); }
    others.forEach(function (c) { c.remove(); });
    state.relatedMode = true;
    var best = matches[0];
    // Same kind of product: the first word of the best match ("Disfraz Azafata…" -> "disfraz").
    var kind = norm(best.getAttribute('data-title')).split(/[^a-z0-9ñ]+/).filter(function (w) { return w.length >= 4; })[0] || '';
    var stem = kind.slice(0, 5);
    var seen = {};
    matches.forEach(function (c) { seen[c.getAttribute('data-id')] = true; });
    var take = function (html, accept) {
      var tmp = document.createElement('div');
      tmp.innerHTML = html;
      return Array.prototype.filter.call(tmp.querySelectorAll('.bali-sx__card'), function (c) {
        var id = c.getAttribute('data-id');
        if (seen[id] || !accept(c)) return false;
        seen[id] = true;
        c.classList.add('is-related');
        return true;
      });
    };
    var sameKind = kind
      ? fetch(searchUrl + '?type=product&options[prefix]=last&q=' + encodeURIComponent(kind) + '&section_id=bali-search-results', { credentials: 'same-origin' })
          .then(function (r) { return r.text(); })
          .then(function (html) { return take(html, function (c) { return new RegExp('(^|[^a-z0-9])' + stem).test(norm(c.getAttribute('data-title'))); }); })
          .catch(function () { return []; })
      : Promise.resolve([]);
    return sameKind.then(function (related) {
      if (related.length >= 3) return related;
      var url = root + 'recommendations/products?product_id=' + best.getAttribute('data-id') + '&limit=8&intent=related&section_id=bali-search-related';
      return fetch(url, { credentials: 'same-origin' }).then(function (r) { return r.text(); })
        .then(function (html) { return related.concat(take(html, function () { return true; })); })
        .catch(function () { return related; });
    }).then(function (related) {
      if (token !== lastToken) return;
      // Products found this way that do contain the searched words are real results, not "related".
      var extra = related.filter(isMatch);
      extra.forEach(function (c) { c.classList.remove('is-related'); });
      related = related.filter(function (c) { return extra.indexOf(c) < 0; });
      state.exact = matches.length + extra.length;
      orderCards(matches.concat(extra), related);
      // Categories built from the loose matches go too, unless they fit the remaining products or the words.
      var types = {};
      cards().forEach(function (c) { types[norm(c.getAttribute('data-type'))] = true; });
      Array.prototype.forEach.call(panel.querySelectorAll('.bali-sx__cat'), function (a) {
        var name = norm((a.querySelector('.bali-sx__cat-name') || a).textContent).trim();
        var keep = types[name] || words.some(function (w) { return name.indexOf(w) >= 0; });
        if (!keep) a.closest('li').remove();
      });
      var catBlock = panel.querySelector('.bali-sx__cat');
      if (!catBlock) {
        Array.prototype.forEach.call(panel.querySelectorAll('.bali-sx__block'), function (b) {
          if (!b.querySelector('li')) b.remove();
        });
      }
    });
  }
  function orderCards(primary, related) {
    var box = panel.querySelector('.bali-sx__cards');
    if (!box) return;
    var more = box.querySelector('[data-sx-more]');
    var byStock = function (arr) {
      return arr.filter(function (c) { return c.getAttribute('data-available') === 'true'; })
        .concat(arr.filter(function (c) { return c.getAttribute('data-available') !== 'true'; }));
    };
    byStock(primary).concat(byStock(related)).forEach(function (c) { box.insertBefore(c, more); });
  }

  function renderShowing() {
    var el = panel.querySelector('[data-sx-showing]');
    if (!el) return;
    var html = 'Mostrando resultados para <strong>“' + esc(state.effective) + '”</strong>';
    if (state.effective.toLowerCase() !== state.typed.toLowerCase()) {
      html += ' · <a href="' + searchUrl + '?type=product&q=' + encodeURIComponent(state.typed) + '" class="bali-sx__only">Buscar solo “' + esc(state.typed) + '”</a>';
    }
    el.innerHTML = html;
  }

  function cards() { return Array.prototype.slice.call(panel.querySelectorAll('.bali-sx__card')); }

  function renderChips() {
    var box = panel.querySelector('[data-sx-chips]');
    if (!box) return;
    var list = cards();
    if (!list.length) { box.innerHTML = ''; return; }
    // Group product types written differently in the store ("Lenceria" / "Lencería") under one chip.
    var counts = {};
    var labels = {};
    list.forEach(function (c) {
      var t = c.getAttribute('data-type');
      if (!t) return;
      var key = norm(t);
      counts[key] = (counts[key] || 0) + 1;
      if (!labels[key] || /[áéíóúñ]/i.test(t)) labels[key] = t;
    });
    var types = Object.keys(counts).sort(function (a, b) { return counts[b] - counts[a]; }).slice(0, 3);
    var prices = list.map(function (c) { return parseInt(c.getAttribute('data-price'), 10) || 0; }).sort(function (a, b) { return a - b; });
    var median = prices[Math.floor(prices.length / 2)];
    var cap = Math.ceil(median / 1000000) * 1000000; // round up to the next $10.000 COP (prices are in cents)
    var hasCheaper = prices[0] <= cap && prices[prices.length - 1] > cap;
    var check = '<svg viewBox="0 0 16 16" aria-hidden="true" focusable="false"><path d="m3.5 8.5 3 3 6-7" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    var html = '<button type="button" class="bali-sx__chip" data-chip="all">' + check + 'Todos</button>';
    types.forEach(function (t) { html += '<button type="button" class="bali-sx__chip" data-chip="type:' + esc(t) + '">' + check + esc(labels[t]) + '</button>'; });
    if (hasCheaper) html += '<button type="button" class="bali-sx__chip" data-chip="max:' + cap + '">' + check + 'Hasta ' + money(cap) + '</button>';
    html += '<a class="bali-sx__chip bali-sx__chip--more" href="' + searchUrl + '?type=product&q=' + encodeURIComponent(state.effective) + '">' +
      '<svg viewBox="0 0 16 16" aria-hidden="true" focusable="false"><path d="M2 4h12M4.5 8h7M7 12h2" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>Más filtros</a>';
    box.innerHTML = html;
  }

  function applyFilter() {
    var chip = state.activeChip;
    Array.prototype.forEach.call(panel.querySelectorAll('.bali-sx__chip[data-chip]'), function (b) {
      b.classList.toggle('is-active', b.getAttribute('data-chip') === chip);
    });
    var visible = 0;
    var hiddenMatches = [];
    cards().forEach(function (c) {
      var ok = chip === 'all' ||
        (chip.indexOf('type:') === 0 && norm(c.getAttribute('data-type')) === chip.slice(5)) ||
        (chip.indexOf('max:') === 0 && (parseInt(c.getAttribute('data-price'), 10) || 0) <= parseInt(chip.slice(4), 10));
      var show = ok && visible < 3;
      c.hidden = !show;
      c.classList.toggle('is-primary', show && visible === 0);
      if (show) visible++;
      else if (ok) hiddenMatches.push(c);
    });
    state.hiddenMatches = hiddenMatches;
    renderTotals();
  }

  function renderTotals() {
    var list = cards();
    var total = state.total !== null && state.activeChip === 'all' ? state.total : null;
    var shown = list.filter(function (c) { return !c.hidden; }).length;
    var matches = shown + (state.hiddenMatches ? state.hiddenMatches.length : 0);
    var count = total !== null ? total : matches;
    var countEl = panel.querySelector('[data-sx-count]');
    if (countEl) countEl.textContent = '(' + (state.relatedMode && state.activeChip === 'all' ? state.exact : count) + ')';
    var cta = panel.querySelector('[data-sx-cta]');
    if (cta) {
      cta.innerHTML = state.relatedMode
        ? 'Ver resultados para “' + esc(state.effective) + '” <span aria-hidden="true">→</span>'
        : 'Ver los ' + count + ' resultados para “' + esc(state.effective) + '” <span aria-hidden="true">→</span>';
    }
    var more = panel.querySelector('[data-sx-more]');
    if (!more) return;
    var rest = count - shown;
    if (rest <= 0) { more.hidden = true; return; }
    more.hidden = false;
    var thumbs = (state.hiddenMatches || []).slice(0, 3).map(function (c) { return c.getAttribute('data-thumb'); }).filter(Boolean);
    if (thumbs.length < 3) thumbs = thumbs.concat(list.map(function (c) { return c.getAttribute('data-thumb'); }).filter(Boolean)).slice(0, 3);
    panel.querySelector('[data-sx-more-thumbs]').innerHTML = thumbs.map(function (src) { return '<img src="' + esc(src) + '" alt="" decoding="async">'; }).join('');
    panel.querySelector('[data-sx-more-text]').innerHTML = state.relatedMode
      ? '<strong>+' + rest + ' productos relacionados</strong>'
      : '<strong>+' + rest + ' productos más</strong> para “' + esc(state.effective) + '”';
  }

  function items() {
    return Array.prototype.filter.call(panel.querySelectorAll('[data-sx-item]'), function (el) { return !el.closest('[hidden]'); });
  }
  function setActive(i) {
    var list = items();
    list.forEach(function (el) { el.classList.remove('is-active'); });
    if (!list.length) { state.activeIndex = -1; return; }
    state.activeIndex = (i + list.length) % list.length;
    list[state.activeIndex].classList.add('is-active');
    list[state.activeIndex].scrollIntoView({ block: 'nearest' });
  }

  // Take over the input event before the stock SearchBar (delegated on an ancestor) sees it.
  input.addEventListener('input', function (event) {
    event.stopPropagation();
    clearTimeout(timer);
    state.completion = state.completion && state.completion.toLowerCase().indexOf(input.value.toLowerCase()) === 0 ? state.completion : '';
    setGhost();
    timer = setTimeout(run, 180);
  });

  input.addEventListener('focus', function () {
    if (input.value.trim() && panel.querySelector('.bali-sx__data, .bali-sx__grid')) open();
  });

  input.addEventListener('keydown', function (event) {
    if ((event.key === 'Tab' || event.key === 'ArrowRight') && state.completion && input.value && input.selectionStart === input.value.length &&
        state.completion.toLowerCase() !== input.value.toLowerCase()) {
      event.preventDefault();
      event.stopPropagation();
      input.value = state.completion;
      setGhost();
      run();
      return;
    }
    if (!isOpen()) return;
    if (event.key === 'ArrowDown') { event.preventDefault(); setActive(state.activeIndex + 1); }
    else if (event.key === 'ArrowUp') { event.preventDefault(); setActive(state.activeIndex - 1); }
    else if (event.key === 'Enter' && state.activeIndex >= 0) {
      var el = items()[state.activeIndex];
      if (el && el.href) { event.preventDefault(); window.location.href = el.href; }
    } else if (event.key === 'Escape') { close(); }
  }, true);

  panel.addEventListener('click', function (event) {
    var fill = event.target.closest('[data-fill]');
    if (fill) {
      event.preventDefault();
      input.value = fill.getAttribute('data-fill');
      input.focus();
      run();
      return;
    }
    var chip = event.target.closest('.bali-sx__chip[data-chip]');
    if (chip) {
      event.preventDefault();
      state.activeChip = chip.getAttribute('data-chip');
      applyFilter();
      return;
    }
    var add = event.target.closest('[data-sx-add]');
    if (add) {
      event.preventDefault();
      if (add.classList.contains('is-busy')) return;
      add.classList.add('is-busy');
      fetch(root + 'cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ id: parseInt(add.getAttribute('data-sx-add'), 10), quantity: 1 })
      }).then(function (r) {
        add.classList.remove('is-busy');
        if (!r.ok) throw new Error('add');
        add.classList.add('is-added');
        add.querySelector('span').textContent = 'Añadido';
        document.documentElement.dispatchEvent(new CustomEvent('product:added', { bubbles: true, detail: { button: add, variant: null, quantity: 1 } }));
        setTimeout(function () { add.classList.remove('is-added'); add.querySelector('span').textContent = 'Añadir'; }, 2200);
      }).catch(function () {
        add.classList.remove('is-busy');
        add.querySelector('span').textContent = 'No disponible';
      });
    }
  });

  var clearBtn = form.querySelector('[data-action="clear-input"]');
  if (clearBtn) clearBtn.addEventListener('click', function () { state.completion = ''; setGhost(); close(); });

  document.addEventListener('click', function (event) {
    if (!isOpen()) return;
    if (!wrapper.contains(event.target) || event.target.closest('[data-bali-search-overlay]')) close();
  });
  document.addEventListener('keydown', function (event) { if (event.key === 'Escape' && isOpen()) close(); });
  window.addEventListener('resize', function () { if (isOpen()) place(); });
  // Phone: the search bar is always visible under the header, so the magnifier icon is not needed (CSS hides it).
  var headerEl = wrapper.closest('.header');
  var phone = window.matchMedia('(max-width: 640px)');
  function syncPhoneBar() {
    if (!headerEl) return;
    headerEl.classList.toggle('header--search-expanded', phone.matches);
    wrapper.classList.toggle('is-visible', phone.matches);
  }
  syncPhoneBar();
  if (phone.addEventListener) phone.addEventListener('change', syncPhoneBar); else if (phone.addListener) phone.addListener(syncPhoneBar);

  var closeMobile = form.querySelector('[data-action="unfix-search"]');
  if (closeMobile) closeMobile.addEventListener('click', close);
})();
